import _startCase from 'lodash/startCase';
import _toLower from 'lodash/toLower';

// Quick validation https://stackoverflow.com/a/32686261
export function isValidEmail() {
  var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
export function isValidPhoneNumber() {
  var phoneNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(phoneNumber);
}
export function randomHex(length) {
  var text = '';
  for (var i = 0; i < length; i += 1) {
    text += Math.random().toString(16).slice(2, 3);
  }
  return text;
}
export function capitalize(word) {
  return _startCase(_toLower(word || ''));
}